module.exports = __webpack_public_path__ + "img/whatsapp-new.467afcd9.svg";